import { Component, OnInit, Inject, HostBinding } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
export interface DialogData {
	message: string;
}
@Component({
	selector: 'common-error-message',
	templateUrl: './error-message.component.html',
	styleUrls: ['./error-message.component.scss']
})
export class ErrorMessageComponent implements OnInit {
	@HostBinding('class.c-bill-error-message') hostClass = true;

	constructor(
		public dialogRef: MatDialogRef<ErrorMessageComponent>,
		@Inject(MAT_DIALOG_DATA) public data: DialogData
	) {}

	ngOnInit() {}
	onNoClick(): void {
		this.dialogRef.close();
	}
}
